module.exports = __webpack_public_path__ + "img/annie.566f20a7.jpg";